export default {"src":"https://marketing.bounce.com/_next/static/media/play-store.3347bbff.svg","height":25,"width":119,"blurWidth":0,"blurHeight":0};